import dynamic from 'next/dynamic'
import { ReactNode } from 'react'

import { SplashOverlay } from '../ui'

const SimpleLayoutClient = dynamic(() => import('./simple-layout-client'), {
  ssr: false,
  loading: () => <SplashOverlay />,
})

export const SimpleLayout = ({ children }: { children: ReactNode }) => {
  return <SimpleLayoutClient>{children}</SimpleLayoutClient>
}
